/**
 * Run a command that only exists while its page is mounted, from anywhere: go to the page,
 * then run the command as soon as the page registers it. "New item" from Overview opens the
 * Missions page with the New item dialog already open.
 */
import { getCommand, useCommandStore } from '../../lib/commands.ts';

/** Gives up after this long (the page failed to load, or its data never arrived). */
export const LAUNCH_TIMEOUT_MS = 8000;

export function runOnPage(commandId: string, path: string, navigate: (to: string) => void): void {
  const now = getCommand(commandId);
  if (now) {
    void now.perform();
    return;
  }
  navigate(path);
  let done = false;
  const finish = () => {
    done = true;
    unsub();
    clearTimeout(timer);
  };
  const unsub = useCommandStore.subscribe(() => {
    if (done) return;
    const c = getCommand(commandId);
    if (!c) return;
    finish();
    // Let the page finish rendering before its dialog opens.
    setTimeout(() => void c.perform(), 0);
  });
  const timer = setTimeout(finish, LAUNCH_TIMEOUT_MS);
}

/** The Missions page's own commands, run from anywhere. */
export const openNewItem = (navigate: (to: string) => void) => runOnPage('missions.item.new', '/missions', navigate);
export const openNewMission = (navigate: (to: string) => void) => runOnPage('missions.new', '/missions?tab=missions', navigate);
